import {
    FormGroup,
    Box,
    FormLabel,
    FormControl,
    ListItemText,
    TextField,
    Checkbox,
    FormControlLabel,
    Select,
    InputLabel,
    MenuItem,
    Button,
    ButtonGroup,
    IconButton,
} from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import axios from "axios";
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import PropagateLoader from "react-spinners/PropagateLoader";
import Backdrop from '@mui/material/Backdrop';
import MUIDataTable from "mui-datatables";
import CheckIcon from '@mui/icons-material/Check';
import { socket, SocketContext } from '../../context/socket';
import { useSnackbar } from 'notistack';
import { SnackbarProvider } from 'notistack';
// import PIsPopup from './PisPopup';
import EditButtonPopup from './EditButtonPopup';
import DeleteConfirmation from '../Reusable/DeleteConfirmation';

import AuthContext from '../../auth/auth';
import React, {useState, useRef, useContext, Redirect, useEffect} from "react";
const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV

async function getInitialData({setGetLoad, setData, setPIsReceived, pisReceived, user}) {
    if (pisReceived === false) {
        try {
            const res =  await axios.get(API_ENDPOINT + "/pi/all");
            let dataToBeUsed = [];
            res.data.forEach((element) => {
                let oneRow = {};
                Object.keys(element).forEach(el => {
                    if (el == "__v") {
                    } else {
                        oneRow = {...oneRow,[el]:element[el]}
                    }
                })
                dataToBeUsed = [...dataToBeUsed,oneRow]
            })
            setData(dataToBeUsed);
            setGetLoad(false);
            setPIsReceived(true);
        } catch (error) {
            console.log(error);
        }
    } else {
        //DO Nothing
    }
    
}

function CurrentPIsTable(props) {
    const [getLoad, setGetLoad] = useState(true);
    const[data,setData] = useState([]);
    const [pisReceived, setPIsReceived] = useState(false);
    const [submitLoad, setSubmitLoad] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(false);
    const [submitResponse, setSubmitResponse] = useState(null);
    const [submitSucess, setSubmitSucess] = useState(true);
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState(null);
    const [currPI, setCurrPI] = useState(null);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const user = useContext(AuthContext);

    // Handle the displaying of the modal
    const showDeleteModal = (currPI) => {
        setCurrPI(currPI);
        setDeleteMessage(`Are you sure you want to delete ${currPI.PIName}'s profile?`);
        setDisplayConfirmationModal(true);
    };
      // Hide the modal
    const hideConfirmationModal = () => {
        setDisplayConfirmationModal(false);
    };

    const handleClose = () => {setSubmitStatus(false)};
    const handleDelete = (thisPI) => {
        return async (event) => {
            setSubmitLoad(true);
            try {
                var res = await axios.delete(API_ENDPOINT + '/pi/delete', { data: thisPI});
                var status = res.status
                if (status === 201) {
                    socket.emit('deletepi', currPI.PIName, user.firstName, user.lastName);
                    setSubmitSucess(true);
                    setSubmitResponse("Delete sucessfully!")
                }
            } catch {
                setSubmitSucess(false);
                setSubmitResponse("Unsucessful! Please try again later or contact adminsitrator if problem persists")
            }
        setDisplayConfirmationModal(false); 
        setSubmitStatus(true);
        setSubmitLoad(false);
        }
    }

    useEffect(() => {
        getInitialData({setGetLoad, setData, setPIsReceived, pisReceived, user}).catch(console.error);
    }, [pisReceived])

    const columns = [
        {
            label: 'PI Name',
            name: 'PIName',
            options: {
                filter: false,
            },
        },
        {
            label: 'University',
            name: 'university',
            options: {
                filter: false,
                
            },
        },
        {
            label: 'University Tag',
            name: 'universityTag',
            options: {
                filter: false,
                // display: 'excluded',
            },
        },
        {
            label: 'Worktag',
            name: 'workTag',
            options: {
                filter: false,
                display: 'excluded',
            },
        },
        {
            label: 'ID',
            name: 'piid',
            options: {
                filter: false,
                // display: 'excluded',
            },
        },
        {
            label: 'User',
            name: 'user',
            options: {
                filter: false,
                // display: 'excluded',
            },
        },
        {
            label: 'Expand',
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (value) => {
                    return (
                      <IconButton>
                        {/* <PIsPopup currentPI={data[value]}/> */}
                      </IconButton>
                    )
                },
                display: 'excluded',
            }
        },
        {
            label: "Operation",
            name: "operation",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                        <EditButtonPopup pis = {data[dataIndex]}/>
                        {/* <br></br>
                        <Button variant="outlined" onClick={() => showDeleteModal(data[dataIndex])} size = "small" disabled={true}> Delete</Button> */}
                        </>
                    );
                }
            }
        },
    ];

    const options = {
        filter: true,
        filterType: 'multiselect',
        print: false,
        viewColumns: false,
        responsive: 'standard',
        selectableRowsHideCheckboxes: true,
        setFilterChipProps: (colIndex, colName, data) => {
            return {
                color: 'primary',
                variant: 'outlined',
                className: 'testClass123',
            };
        },
    };

    return (
        <div>
            <Grid container
                direction="column"
                alignItems="center"
                spacing={0}
                margin={0}>
                <Backdrop
                    sx={{ color: '#fff', zIndex: 1 }}
                    open={getLoad}
                >
                    <PropagateLoader/>
                </Backdrop>
                <Backdrop
                    sx={{ color: '#fff', zIndex: 1 }}
                    open={submitStatus}
                    onClick={handleClose}
                >
                    {submitSucess ?
                    (<Alert onClose={() => {setSubmitStatus(false); window.location.reload(false);}} icon={<CheckIcon fontSize="inherit" />} severity="success">
                    {submitResponse}
                    </Alert>) : (
                    <Alert onClose={() => {setSubmitStatus(false)}} severity="error">
                    {submitResponse}
                    </Alert>)
                    }
                </Backdrop>
            </Grid>
            <MUIDataTable title={'PIs'}
                data={data.map(item => {
                    return [
                        item.PIName,
                        item.university,
                        item.universityTag,
                        item.workTag,
                        item.piid,
                        item.username,
                    ]
                })}
                columns={columns}
                options={options}
            />
            <DeleteConfirmation 
                showModal={displayConfirmationModal} 
                confirmModal={handleDelete} 
                hideModal={hideConfirmationModal} 
                id={currPI} 
                message={deleteMessage}  
            />
        </div>
    )
}

export default CurrentPIsTable;